import { render, staticRenderFns } from "./PageContentMobileContent.vue?vue&type=template&id=0aadc69b&scoped=true"
import script from "./PageContentMobileContent.vue?vue&type=script&lang=js"
export * from "./PageContentMobileContent.vue?vue&type=script&lang=js"
import style0 from "./PageContentMobileContent.vue?vue&type=style&index=0&id=0aadc69b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadc69b",
  null
  
)

export default component.exports